import { render, staticRenderFns } from "./releaseArticle.vue?vue&type=template&id=42593fc9&scoped=true"
import script from "./releaseArticle.vue?vue&type=script&lang=js"
export * from "./releaseArticle.vue?vue&type=script&lang=js"
import style0 from "./releaseArticle.vue?vue&type=style&index=0&id=42593fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42593fc9",
  null
  
)

export default component.exports